import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { fontMerriweather, fontRoboto } from "shared/lib/styles";

type LiveTagProps = {
  $dim?: boolean;
  $hide?: boolean;
  $variant?: "default" | "transparent";
};

export const LiveTag = styled.div<LiveTagProps>`
  display: inline-flex;
  flex-flow: row;
  gap: 4px;
  justify-content: center;
  align-items: center;

  block-size: 24px;
  padding-block: 6px;
  padding-inline: 6px 8px;

  font-weight: 700;
  font-size: 14px;
  font-family: ${fontMerriweather};
  line-height: 12px;

  background-color: #ffca05;

  @keyframes fadeInOut {
    0%,
    100% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
  }

  &:before {
    content: "";

    display: inline-block;

    inline-size: 12px;
    block-size: 12px;

    border-radius: 50%;

    background-color: #ffffff;

    animation: fadeInOut 1s infinite;
  }

  ${props =>
    props.$variant === "transparent" &&
    css`
      padding: 0;

      color: #eb4254;
      font-weight: 700;
      font-size: 12px;
      font-family: ${fontRoboto};
      line-height: 14px;

      background-color: transparent;

      &:before {
        background-color: #eb4254;
      }
    `}

  ${props =>
    props.$hide &&
    css`
      display: none;
    `}

  ${props =>
    props.$dim &&
    css`
      background: ${props.$variant === "transparent" ? "transparent" : "#cccccc"};

      &:before {
        background: #999999;

        animation: none;
      }
    `}
`;
